/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface CheckoutSessionResponse
 */
export interface CheckoutSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    url: string;
}

export function CheckoutSessionResponseFromJSON(json: any): CheckoutSessionResponse {
    return {
        'url': json['url'],
    };
}

export function CheckoutSessionResponseToJSON(value?: CheckoutSessionResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'url': value.url,
    };
}


